module.exports = lottie;